import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import renderRichText from '@utils/richtext'
import TracklineWrapper from '@objects/tracklineWrapper'
import Container from '@objects/container'
import Headline from '@objects/headline'
import InfoIcon from '@static/img/icons/info.svg'

const useStyles = makeStyles((theme) => ({
  iconWrapper: {
    display: 'flex',
    width: '72px',
    height: '72px',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#FFCC00',
    borderRadius: '50%',
    marginBottom: '1rem',
  },
  icon: {
    width: '10px',
    height: '36px',
    fill: '#00385E',
  },
  textWrapper: {
    maxWidth: '584px',
  },
  copy: {
    fontSize: '16px',
    lineHeight: '25px',
  },
}))

function InfoBox({ headline, copy }) {
  const classes = useStyles()

  return (
    <TracklineWrapper topbottom={true} firstcircle="halfvert" secondcircle="t">
      <Container className="bg-gray-light-300 md:px-9 md:pt-8 md:pb-8">
        <div className={classes.iconWrapper}>
          <img src={InfoIcon} alt="Information" className={classes.icon} />
        </div>

        {headline && (
          <Headline className="mb-9" ariaLabel={headline}>
            {headline}
          </Headline>
        )}
        {copy && (
          <div className={classes.textWrapper}>
            <div className={classes.copy}>
              {copy?.raw ? renderRichText(copy) : copy}
            </div>
          </div>
        )}
      </Container>
    </TracklineWrapper>
  )
}

InfoBox.propTypes = {
  headline: PropTypes.string,
  copy: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default InfoBox
